import { render, staticRenderFns } from "./MakeSetMeal.vue?vue&type=template&id=ca3438cc&scoped=true&"
import script from "./MakeSetMeal.vue?vue&type=script&lang=js&"
export * from "./MakeSetMeal.vue?vue&type=script&lang=js&"
import style0 from "./MakeSetMeal.vue?vue&type=style&index=0&id=ca3438cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3438cc",
  null
  
)

export default component.exports